import React, { useCallback } from 'react';
import ErrorState from '@atlassian/jira-common-components-error-state/src/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const PageErrorState = (): React.JSX.Element => {
	const descriptionGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.descriptionGalaxia
		: messages.description;
	const { formatMessage } = useIntl();

	const onRetry = useCallback(() => {
		if (typeof window !== 'undefined') {
			window.location.reload();
		}
	}, []);

	return (
		<ErrorState
			header={formatMessage(messages.header)}
			description={formatMessage(descriptionGalaxia)}
			onRetry={onRetry}
		/>
	);
};
